module.exports = __webpack_public_path__ + "static/reporting-989ab8819509a85c592bde842eb629d6.png";